module.exports = __webpack_public_path__ + "static/media/Logo2.3de45035.png";